import styled from "styled-components";

const ButtonMiTelcel = styled.button`
  border: ${(props) => 
    props.isEnabled ? "1px solid black" : "1px solid #ccc"};
  border-radius: 25px;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "12px")};
  background:${(props) => (props.isEnabled ? "#000" : "#ccc")};
  color: ${(props) => (props.isEnabled ? "#fff" : "#999")};
  text-align: center;
  font-family:'AMX-Bold';
  padding:${(props) => (props.padding ? props.padding : "8px 15px;")}; 
  font-weight: ${(props) => (props.weight ? props.weight : "bold")};
  margin: ${(props) => (props.margin ? props.margin : "0%")};
  display : ${(props) => (props.display ? props.display : "inline-block")}
  width : ${(props) => (props.width ? props.width : "100%")}
`;

export const ButtonMiTelcelContenedor = styled.button`
    border: none;
    border-radius: 56px;
    width: 90%;
    padding: 10px 10px 9px 10px;
    background: ${props => props.active ? "#7B1FA2" : "#E3E3E3"};
    color: ${props => props.active ? "#ffffff" : "#ACACAC"}
    font-family: AMX-Bold;
    font-size: 16px;
`;

export const ButtonMiTelcelContenedorWhite = styled.button`
    border: ${props => props.active ? "1px solid #7B1FA2" : "1px solid #d0d0d0"};
    border-radius: 56px;
    width: 100%;
    padding: 11px 0px 9px;
    background: ${props => props.active ? "#ffffff" : "#d0d0d0"};
    color: ${props => props.active ? "#7B1FA2" : "#595959"}
    font-family: AMX-Bold;
    font-size: 16px;
`;

export default ButtonMiTelcel;